import { DATE_FORMATS_FNS } from "components/DatePicker";
import { useGetDistrimateRecallStatusName } from "components/Recalls/utils";
import { formatDate } from "utils/dateHelperFunctions";

import type { RECALL_ENTITY_STATUSSES } from "models";

type PreviousRecallRowPops = {
  label: string;
  status?: RECALL_ENTITY_STATUSSES;
  endDate?: string | null;
};

export const PreviousRecallRow = ({ label, status, endDate }: PreviousRecallRowPops) => {
  const { getDistrimateRecallStatusName } = useGetDistrimateRecallStatusName();

  return (
    <div className="OpenRecalls-item OpenRecalls-layout-3">
      <span>{label}</span>
      {status && <span>{getDistrimateRecallStatusName(status)}</span>}
      {endDate ? <span>{formatDate(endDate, DATE_FORMATS_FNS.dateMonthYear)}</span> : <div className="OpenRecalls-filler"></div>}
      <div className="OpenRecalls-filler"></div>
    </div>
  );
};
